import { orchestrator } from 'satcheljs';
import {
    discardEvent,
    discardQuickComposeEvent,
    prepareEvent,
    presentDiscardClosureConfirmation,
} from 'owa-calendar-compose-form-actions';
import { getQuickComposeViewState } from 'owa-calendar-compose-store-manager';

orchestrator(discardQuickComposeEvent, actionMessage => {
    prepareEvent(actionMessage.formId);

    if (getQuickComposeViewState(actionMessage.formId).viewType == 'TimePanel') {
        // If it is timepanel, we show confirmation dialog
        presentDiscardClosureConfirmation(actionMessage.formId, undefined /* targetWindow */);
    } else {
        discardEvent(actionMessage.formId);
    }
});
